import { useNavigate, useSearch } from '@tanstack/react-router';
import { PageHeader } from '@/shared/components';
import { GuestEmailsSection } from './GuestEmailsSection';
import { QrPosterSection } from './qr-poster/QrPosterSection';

/**
 * Gastzugänge (Board „Buchungen · Gastzugänge“): hängende Zustellungen und alle Zugänge, daneben
 * der QR-Poster fürs Haus. Der Reiter steht in der URL (`?tab=qr-poster`), damit Zurück und ein
 * geteilter Link denselben Reiter öffnen.
 */
export function OnboardingLinksPage() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { tab?: string };
  const poster = search.tab === 'qr-poster';
  const show = (tab: 'qr-poster' | undefined) =>
    void navigate({ to: '/system/onboarding-links', search: { tab } as never });
  return (
    <>
      <PageHeader
        title="Gastzugänge"
        description="Zustellung hängt – und der QR-Poster fürs Haus."
        filterTabs={[
          { label: 'Zugänge', active: !poster, onSelect: () => show(undefined) },
          { label: 'QR-Poster', active: poster, onSelect: () => show('qr-poster') },
        ]}
        filterTabsLabel="Reiter"
        filterTabsKind="tabs"
      />
      {poster ? <QrPosterSection /> : <GuestEmailsSection />}
    </>
  );
}
